export default __webpack_public_path__ + "images/d3027a6e6da109e0d996e167253ac28b-boxing.png";